import { Component, computed, inject, input, Signal, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { CountriesService } from './countries.service';

@Component({
  selector: 'vectronic-autocomplete-country',
  templateUrl: './autocomplete-country.component.html',
  styleUrls: ['./autocomplete-country.component.scss'],
  imports: [MatInputModule, MatAutocompleteModule, ReactiveFormsModule],
})
export class AutocompleteCountryComponent {
  private countriesService = inject(CountriesService);
  countryControl = input<FormControl>();
  countries: Signal<string[]> = this.countriesService.countriesCommonNames;
  search = signal('');
  filteredCountries = computed(() =>
    this.countries().filter((country) =>
      country.toLowerCase().includes(this.search().toLowerCase()),
    ),
  );
}
